/** 浏览器本地存储中的认证令牌键，供认证状态和请求基础设施共享。 */
export const AUTH_TOKEN_STORAGE_KEY = 'cinematic_gaming_access_token';
